import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function Protected({ children, requireOnboarded = true, adminOnly = false, allowNeedsCard = false }) {
  const { user, loading } = useAuth();
  const { pathname } = window.location;
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen text-zinc-500 uppercase tracking-widest text-sm">
        Loading...
      </div>
    );
  }
  if (!user) return <Navigate to="/auth/login" replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/dashboard" replace />;
  // Card-on-file gate: any user with subscription.status === 'needs_card' must
  // first complete the trial-start flow. Allow the /start-trial route itself
  // (and any explicit opt-out via `allowNeedsCard`) to bypass this redirect.
  // Coach-linked clients skip this gate too — they can browse the app pre-
  // subscription so the coach's engagement loop (WeaknessCard, Messages,
  // Exercise library) has a chance to convert them.
  // Coaches and admins ALSO bypass this — they need full access to their
  // tooling (exercise library, client management) while their own coach
  // subscription is being set up. Premium AI/meal features are gated
  // separately at the endpoint level.
  const status = user.subscription?.status;
  if (
    !allowNeedsCard &&
    (status === "needs_card" || !status) &&
    !pathname.startsWith("/start-trial") &&
    !pathname.startsWith("/auth") &&
    !user.is_admin &&
    !user.is_coach &&
    !user.coach_id
  ) {
    return <Navigate to="/start-trial" replace />;
  }
  // Coaches skip onboarding; clients with no onboarding go to wizard
  if (requireOnboarded && !user.onboarded && !user.is_coach) {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}
